import React from "react";
import Drawer from "@material-ui/core/Drawer";
import Box from "@material-ui/core/Box";
import makeStyles from "@material-ui/core/styles/makeStyles";
import DrawerButton from "./DrawerButton";
import ProjectSelector from "./ProjectSelector";
import {Divider, Hidden} from "@material-ui/core";
import {CustomTheme} from "../../constants/theme";
import {help, useNavigationList} from "../../constants/NavigationList";
import SignOutIcon from 'remixicon-react/LogoutCircleLineIcon';
import {useDispatch} from "react-redux";
import {authActions} from "../../store/AuthState";

const useStyles = makeStyles<CustomTheme>((theme) => ({
    drawer: {
        width: theme.custom.drawerWidth,
        flexShrink: 0,
        [theme.breakpoints.down("sm")]: {
            display: 'none',
        },
    },
    drawerPaper: {
        width: theme.custom.drawerWidth,
        border: 'none',
        boxShadow: '0 2px 5px rgba(0,0,0,.09)',
        overflowX: 'hidden',
    },
    drawerTop: {
        padding: theme.spacing(0, 2),
        height: theme.custom.appBarHeight
    }
}));

interface DashboardDrawerProps {
    mobileOpen: boolean;
    onMobileToggle: () => void;
}

export const DashboardDrawer: React.FC<DashboardDrawerProps> = ({mobileOpen, onMobileToggle}) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const navList = useNavigationList();


    const handleSignOut = () => dispatch(authActions.signOut());

    const drawer = (
        <Box display="flex" flexDirection="column" flexGrow={1}>
            <div className={classes.drawerTop}>
                <ProjectSelector/>
            </div>
            <Divider/>
            {navList.map((item) => <DrawerButton
                key={item.path}
                item={item}
                onToggle={onMobileToggle}
            />)}
            <Box flex={1}/>
            <DrawerButton
                iconColor="#84909c"
                textColor="#84909c"
                item={help}
            />
            <Divider/>
            <DrawerButton
                onClick={handleSignOut}
                iconColor="#84909c"
                textColor="#84909c"
                item={{
                    name: 'Log ud',
                    icon: SignOutIcon,
                    path: '',
                }}
            />
        </Box>
    )

    const container = window !== undefined ? () => window.document.body : undefined;

    return (
        <nav className={classes.drawer} aria-label="navigation">
            <Hidden smUp implementation="css">
                <Drawer
                    container={container}
                    variant="temporary"
                    anchor="left"
                    open={mobileOpen}
                    onClose={onMobileToggle}
                    classes={{paper: classes.drawerPaper}}
                    // Better open performance on mobile.
                    ModalProps={{keepMounted: true}}
                >
                    {drawer}
                </Drawer>
            </Hidden>
            <Hidden smDown implementation="css">
                <Drawer
                    classes={{paper: classes.drawerPaper}}
                    variant="permanent"
                    open
                >
                    {drawer}
                </Drawer>
            </Hidden>
        </nav>
    )
}

export default DashboardDrawer;



